// start:ng42.barrel
export * from './ITrackingJson';
// end:ng42.barrel




// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/interfaces/TrackingJson/index.ts